// <s-sticky-atc> reveals the mobile add-to-cart bar once the main add-to-cart button scrolls out of view.
class StickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const form = this.closest('form');
    const mainButton = form?.querySelector('[data-main-atc]');
    if (!mainButton || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      // Only show after the user has scrolled past the button, not before reaching it.
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', show);
      this.toggleAttribute('inert', !show);
      this.setAttribute('aria-hidden', String(!show));
    });
    this.#observer.observe(mainButton);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', StickyAtc);
